<template>
  <div>
    <component
      :is="marketCode"
      :dataSource="dataSource"
      v-bind.sync="currentClient"
      :market="market"
      :is-disabled="isDisabled"
    />
  </div>
</template>
<script>
import Base from './Base'
import Generic from './GenericMarketTab'

export default {
  props: {
    market: {
      type: Object,
      validator: v => 'marketId' in v && 'marketCode' in v,
    },
    dataSource: {
      type: Object,
      required: true,
    },
    currentClient: {
      type: Object,
      required: true,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Base,
    Generic,
  },
  computed: {
    marketCode() {
      if (this.market.marketCode === 'Base') {
        return 'Base'
      }

      return 'Generic'
    },
  },
}
</script>
